import { FilterValue } from "../Filters/FilterValue";

export const ProjectSortingField: FilterValue[] = [
  { id: "dispatch_date", value: "Dispatch Date" },
  { id: "created_date", value: "Created Date" },
];
